import { render, staticRenderFns } from "./VQCompanyHouseName.vue?vue&type=template&id=510b9806&scoped=true"
import script from "./VQCompanyHouseName.vue?vue&type=script&lang=js"
export * from "./VQCompanyHouseName.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "510b9806",
  null
  
)

export default component.exports